<template>
    <div >
        <!-- nuevos campos -->
        <v-row>
        <v-col cols="12" md="8" >
          <v-select
              :items="listaEnsayo"
              v-model="form_data.data_ensayo.tipoEnsa"
              item-text="value"
              item-value="id"
              label="ENSAYO"
              outlined
              dense
              required
          ></v-select>
        </v-col>
        <v-col cols="12" md="4" >
          <v-btn
            color="primary"
            class="mr-4"
          >
            agregar nuevo ensayo +
          </v-btn>
        </v-col>
        </v-row>

        <v-row>
        <v-col cols="12" md="4" >
          <v-select
              :items="listaEmpresa"
              v-model="form_data.data_ensayo.empresa"
              item-text="value"
              item-value="id"
              label="EMPRESA"
              outlined
              dense
              required
          ></v-select>
        </v-col>
        <v-col cols="12" md="4" >
          <v-select
              :items="listaProductos"
              v-model="form_data.data_ensayo.prodcuto"
              item-text="value"
              item-value="id"
              label="PRODUCTO"
              outlined
              dense
          ></v-select>
        </v-col>
        <v-col cols="12" md="4" >
          <v-select
              :items="listaParametros"
              v-model="form_data.data_ensayo.parametros"
              item-text="value"
              item-value="id"
              label="PARÁMETROS"
              outlined
              dense
              required
          ></v-select>
        </v-col>
        </v-row>

        <v-row>
        <v-col cols="12" md="12" >
          <v-text-field
            name="descripcion"
            label="DESCRIPCIÓN"
            auto-grow
            ></v-text-field>
        </v-col>
        </v-row>
        <v-row>
        <v-col cols="12" md="12" >
          <v-text-field
            name="metodologia"
            label="METODOLOGÍA"
            auto-grow
            ></v-text-field>
        </v-col>
        </v-row>

        <v-row>
        <v-col cols="12" md="4" >
          <v-text-field
          name="enriquecimiento"
          label="ENRIQUECIMIENTO (Hrs)"
          outlined
          dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" >
          <v-select
              :items="tipoResulados"
              v-model="form_data.data_ensayo.tipoRes"
              item-text="value"
              item-value="id"
              label="TIPO RESULTADO"
              outlined
              dense
          ></v-select>
        </v-col>
        <v-col cols="12" md="4" >
          <v-text-field
          name="tiporesultado"
          label="TIEMPO RESULTADOS (Días)"
          outlined
          dense
          ></v-text-field>
        </v-col>
        </v-row>

        <v-col cols="12" md="4" >
            <p class="font-weight-black">MATRICES Y UNIDADES</p>
            <v-card>
                <v-card-text>
                    <v-row align="center" v-for="(item) in matrices_unidades" :key="item.id">
                        <v-checkbox
                        hide-details
                        class="shrink mr-2 mt-0"
                        v-model="item.activo"
                        @change="activematriz($event,item)"
                        ></v-checkbox>
                        <v-text-field
                        :label="item.value" :disabled="!item.activo" :value="item.unidades"/>
                    </v-row>

                </v-card-text>
            </v-card>
        </v-col>

    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {

  data: () => ({
    listaEnsayo: [],
    listaEmpresa: [],
    listaProductos: [],
    listaParametros: [],
    tipoResulados: [
      {
        id: 0,
        value: 'Cuantitativo',
      },
      {
        id: 1,
        value: 'Cualitativo',
      },
    ],
    matrices_unidades: [
      {
        id: 0,
        value: 'Alimento',
        unidades: 'UFC/25 gr',
        activo: true,
      },
      {
        id: 1,
        value: 'Aguas',
        unidades: ' UFC/100cm^2 ',
        activo: true,
      },
      {
        id: 2,
        value: 'Superficies',
        unidades: '',
        activo: false,
      },
      {
        id: 3,
        value: 'Ambientes',
        unidades: '',
        activo: false,
      },
      {
        id: 4,
        value: 'Manipuladores',
        unidades: '',
        activo: false,
      },
    ],
  }),
  created() {
    // this.matrices = this.form_data.data_matrices;
    // console.log('entra a seleccionar matrices y unidades')
    this.form_data.matrices_unidades = this.matrices_unidades;
  },
  computed: {
    ...mapState('Ensayos', ['form_data', 'obj_matrices']),
  },
  methods: {
    activematriz(ev, item) {
      this.matrices_unidades.forEach((matriz) => {
        if (matriz.id === item.id) {
          if (ev === true) {
            // eslint-disable-next-line
            matriz.activo = true;
          } else {
            // eslint-disable-next-line
            matriz.activo = false;
          }
        }
        return true;
      });
    },
  },
};
</script>
